export const useFormatShippingText = (shippingText: string) => {
  return shippingText.split(" ").map((word, index, arr) => {
    if (!["Receba", "Chegará", "até", "Retire"].includes(word)) {
      return (
        <>
          <b key={word}>{word}</b>
          {index !== arr.length - 1 && " "}
        </>
      );
    }
    return (
      <>
        <span key={word}>{word}</span>
        {index !== arr.length - 1 && " "}
      </>
    );
  });
};
